import React from "react";
import styles from "../EdofDesign/EdofDesign.module.css";

const EdofDesign = () => {
  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <div className={styles.leftSection}>
          <div className={styles.headingSection}>
            <h1 className={styles.title}>
              Patented EDOF Optical Design for Presbyopic Correction
            </h1>
            <h2 className={styles.subtitle}>
              Continuous Focus from Near to Far
            </h2>
          </div>

          <div className={styles.descDiv}>
            <p className={styles.description}>
              Deseyne® daily disposable soft contact lenses use an Extended Depth of Focus (EDOF) optical design engineered to increase depth of focus without relying on multiple optical zones.
            </p>
            <p className={styles.description}>
              Until now, Extended Depth of Focus (EDOF) technology has largely been associated with intraocular lenses requiring permanent surgical implantation. Deseyne® brings an EDOF optical approach to a non-surgical, daily disposable soft contact lens. In FDA-reviewed clinical testing, Deseyne® demonstrated a depth of focus improvement of approximately 0.78 D, with strong intermediate and near visual acuity performance. This measured depth of focus falls within the optical ranges documented in published studies of EDOF intraocular lens technologies.
            </p>
            <p className={styles.description}>
              In FDA-reviewed clinical testing, participants, including those in older presbyopic age groups, demonstrated measurable gains at both intermediate and near distances, with mean visual acuity improving to 20/20 and 20/31.
            </p>
          </div>
        </div>
        <div className={styles.RightSection}>
          <div className={styles.accomendationImage}>
            <img
              src="Images/Accommodative.webp"
              alt="3D graph showing EDOF lenses maintain highest  quality across accommodative range compared to multifocal and no lens"
            loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EdofDesign;
